import { useWindowSize } from '@folklore/hooks';
import { isTouchScreen as getIsTouchScreen } from '@folklore/utils';
import { useState } from 'react';

// On touch screens, the height only changes with the width, to ignore the browser bars showing and
// hiding while scrolling. The first render returns the same height either way, so the detection
// (client only) does not affect hydration.
function useStableWindowHeight() {
    const [isTouchScreen] = useState(getIsTouchScreen);
    const { width, height } = useWindowSize();
    const [{ width: stableWidth, height: stableHeight }, setStableSize] = useState({
        width,
        height,
    });
    if (isTouchScreen && stableWidth !== width) {
        setStableSize({ width, height });
    }
    return isTouchScreen ? stableHeight : height;
}

export default useStableWindowHeight;
